module.exports = __webpack_public_path__ + "static/media/mute_microfono.76f6fb00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Volume/mute_microfono.svg
// module id = 1856
// module chunks = 0